var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseAr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57.531,
    height: 56,
    viewBox: "0 0 57.531 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cloose_ar",
    transform: "translate(-372.979 -342.235)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2022",
    d: "M16.583.5H8.948A8.448,8.448,0,0,0,.5,8.948v7.636",
    transform: "translate(373.479 342.735)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2024",
    d: "M.5,61.919v7.636A8.448,8.448,0,0,0,8.948,78h7.636",
    transform: "translate(373.479 319.232)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2026",
    d: "M78,16.583V8.948A8.448,8.448,0,0,0,69.555.5H61.919",
    transform: "translate(351.507 342.735)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2029",
    d: "M61.919,78h7.636A8.448,8.448,0,0,0,78,69.555V61.919",
    transform: "translate(351.507 319.232)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_15",
    x2: 25,
    y2: 25,
    transform: "translate(389.5 358.735)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_16",
    x1: 25,
    y2: 25,
    transform: "translate(389.5 358.735)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseAr);
export default __webpack_public_path__ + "static/media/close_ar.4fc9444f8cb414ade865e4112c2d8fb1.svg";
export { ForwardRef as ReactComponent };